import { UseCase } from "../../useCase"
import { ExportSurveysRequest } from "./request"
import { ExportSurveysResponse } from "./response"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class ExportSurveysUseCase implements UseCase<ExportSurveysRequest, ExportSurveysResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(request: ExportSurveysRequest): Promise<ExportSurveysResponse> {
		return this._repository.exportSurveys(request.surveyId)
	}
}
